/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * Risk Modelling Platform API
 * The API for the risk modelling platform
 * OpenAPI spec version: 1.0
 */

/**
 * The current workflow state of the ITC project. Used by the FE to map state names to tooltip / disabled-control rationale, mirroring the `Code` field returned on 409 denials from the state-gated mutation endpoints (POST /treatmentareas with fbrOnly, PATCH /projects/{p}/runs/{r} on an IAR, POST /projects/{p}/runs/{r}/asset-groups on an IAR).

 */
export type ServiceITCStateResponseDataAttributesState =
  (typeof ServiceITCStateResponseDataAttributesState)[keyof typeof ServiceITCStateResponseDataAttributesState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceITCStateResponseDataAttributesState = {
  "in-setup": "in-setup",
  "only-fbrs-in-progress": "only-fbrs-in-progress",
  "iars-in-progress": "iars-in-progress",
  "iars-ready-to-run": "iars-ready-to-run",
  "runs-complete": "runs-complete",
  "legacy-itc": "legacy-itc",
} as const;
